/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './grid-item-container.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface GridItemContainerProps {
    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * The row that this grid item container will be displayed in
     */
    row: number;

    /**
     * The column that this grid item container will be displayed in
     */
    column: number;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledGridItemContainer = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const GridItemContainer: FunctionComponent<GridItemContainerProps> = ({
    children,
    column,
    row,
    ...otherProps
}: GridItemContainerProps) => {
    return (
        <StyledGridItemContainer column={column} row={row} {...otherProps}>
            {children}
        </StyledGridItemContainer>
    );
};
